import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { StudentService } from 'src/app/_services/student.service';

@Component({
  selector: 'app-worksheet-download',
  templateUrl: './worksheet-download.component.html',
  styleUrls: ['./worksheet-download.component.css']
})
export class WorksheetDownloadComponent implements OnInit {
  worksheet_code=""
  imageSource=""
  downloading=false
  constructor(private studentService:StudentService,private activeRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe(
      myP=>{
      this.worksheet_code =myP['worksheet_code']

      }
    )
  }
  downloadFreeWorkBook(){
    this.downloading=true
    this.studentService.downloadFreeWorksheet(this.worksheet_code).subscribe({
      next:(data:ResultData)=>{
        this.imageSource= `data:application/pdf;base64,${data.rs.data}`;
        this.downloadMyPdf()
    }
    }
    )
  }



  downloadMyPdf() {
     const link = document.createElement("a");
     let fileName= "boldungu_free_quiz_"+Date.now()
     link.href = this.imageSource;
     link.download = `${fileName}.pdf`
     this.downloading=false
     link.click();
   }
}
